<script setup lang="ts">
/** DR-08 · A project-scoped action was started while the organisation has no project. */
import Dialog from '~/components/ui/Dialog.vue'
import Icon from '~/components/ui/Icon.vue'
import ActionButton from '~/components/ui/ActionButton.vue'

defineProps<{ attempted: string }>()
const emit = defineEmits<{ close: []; create: [] }>()
</script>

<template>
  <Dialog title="No project selected" :meta="attempted" :width="440" @close="emit('close')">
    <template #icon><Icon name="folder" /></template>
    <p class="m-0 text-xs leading-relaxed">Data, models and endpoints belong to a project. Create one, then {{ attempted }} again.</p>
    <template #actions>
      <ActionButton label="Cancel" @click="emit('close')" />
      <ActionButton label="New project" variant="primary" @click="emit('create')"><template #icon><Icon name="plus" /></template></ActionButton>
    </template>
  </Dialog>
</template>
